import React from "react";
import { useNavigate } from "react-router-dom";
import Stocks from "../components/stocks/Stocks";
import support from "../images/contact-support.gif";
import loginIMG from "../images/page.webp";
import mamitoIMG from "../images/mamito.jpeg";
import girlieIMG from "../images/girlie.jpeg";
import broIMG from "../images/bro.jpeg";
import useInView from "../lib/useInView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelopesBulk,
  faLandmarkFlag,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
  const navigate = useNavigate();

  const [box1Ref, box1InView] = useInView({ threshold: 0.7 });
  const [box6Ref, box6InView] = useInView({ threshold: 0.7 });
  const [boxImgRef, boxImgInView] = useInView({ threshold: 0.5 });
  const [box7Ref, box7InView] = useInView({ threshold: 0.7 });
  const [box9Ref, box9InView] = useInView({ threshold: 0.7 });
  const [box8Ref, box8InView] = useInView({ threshold: 0.7 });

  return (
    <>
      <div id="hero-section">
        <div className="hero-section">
          {/* Left Box: Text and Sub-Boxes */}
          <div className="hero-text-container">
            <h1 className="hero-title">New Foundation Card</h1>
            <div id="box-saving">
              <p className="hero-description">
                Our Foundation VISA® Debit Card is designed to help establish
                and strengthen your credit. No monthly service charge, Uses
                funds secured by your interest-bearing Foundation Secured
                Savings Account.{" "}
              </p>
              <p className="hero-description">
                Whether you're saving for college or working toward retirement,
                our goal is to make a difference—for you, your family and your
                future. Solutions to build, preserve and manage wealth Practical
                and personalized guidance{" "}
              </p>
            </div>
            <button
              onClick={() => navigate("/my-card")}
              className="delete-button"
            >
              Apply Now
            </button>
          </div>

          {/* Right Box: Image */}
          <div className="hero-image-container">
            <img
              src={support}
              alt="Hero"
              ref={box1Ref}
              className={`hero-image animate__animated ${box1InView ? "custom-animation" : ""}`}
            />
          </div>
        </div>

        {/* Display Sliding Carousel */}
        <Stocks />
      </div>

      <div>
        <h2 className="box-titles center">
          Contact Support for Prompt Assistance.
        </h2>
        <div className="sub-containers">
          <div className="sub-box">
            <div
              ref={box6Ref}
              className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
            >
              <FontAwesomeIcon icon={faEnvelopesBulk} className="box-icon" />
              <div className="title-text">
                <h3 className="box-title" id="white-title">
                  Email
                </h3>
                <div className="box-text search-container">
                  support@skyhighntb.com (Quick Response)
                </div>
              </div>
            </div>
          </div>
          <div className="sub-box">
            <div
              ref={box6Ref}
              className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
            >
              <FontAwesomeIcon icon={faLandmarkFlag} className="box-icon" />
              <div className="title-text">
                <h3 className="box-title" id="white-title">
                  Head Server Address
                </h3>
                <div className="box-text search-container">
                  Opal Tower, Business Bay, Dubai, UAE
                  {/* 5185 US Route 60 E, Huntington, WV 25705 */}
                </div>
              </div>
            </div>
          </div>
          <div className="sub-box">
            <div
              ref={box6Ref}
              className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
            >
              <FontAwesomeIcon icon={faPhone} className="box-icon" />
              <div className="title-text">
                <h3 className="box-title" id="white-title">
                  Phone Number
                </h3>
                <div className="box-text search-container">
                  VIP ACCESS ONLY - May be congested or unavailable.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* next content here */}
      <div className="main-box-cover">
        <h2 className="text-heading centered">
          More Choices - <span> More Possibilities.</span>
        </h2>
        <div className="hero-description centered">
          We offer our clients comprehensive investment solutions that are
          tailored to each particular client’s needs at a specific period of
          time. For 17 years, we have been providing secure and easy offshore
          banking to over 400,000 who live, travel, shop and work arpund the
          world. We make cross-border banking easy and secure.
        </div>
      </div>

      <div className="last-section">
        <div className="box">
          <img
            ref={boxImgRef}
            src={loginIMG}
            alt="Sky High National Trust Bank"
            className={`box-image animate__animated ${boxImgInView ? "animate__pulse" : ""}`}
          />
          <h2 className="text-heading centered">
            Navigate complexity with a trusted capital markets services partner
            at your side
          </h2>
        </div>
        <div className="box">
          <div
            ref={box7Ref}
            className={`icon-title-text-container animate__animated ${box7InView ? "animate__zoomInRight" : ""}`}
          >
            <img
              src={mamitoIMG}
              className="boxed-icon"
              alt="WORKING AND INVESTING IN THE U.S."
            />
            <div className="title-text">
              <h2 className="box-title">WORKING AND INVESTING IN THE U.S.</h2>
              <div className="hero-description">
                Explore endless career and investment opportunities in the U.S.
                – from building a thriving career to making smart financial
                moves in one of the world's strongest economies.{" "}
              </div>
            </div>
          </div>

          <div
            ref={box8Ref}
            className={`icon-title-text-container animate__animated ${box8InView ? "animate__zoomInRight" : ""}`}
          >
            <img
              src={broIMG}
              className="boxed-icon"
              alt="RELOCATING AND SCHOOLING IN THE U.S."
            />
            <div className="title-text">
              <h2 className="box-title">
                RELOCATING AND SCHOOLING IN THE U.S.
              </h2>
              <div className="hero-description">
                Make your move to the U.S. seamless—discover the best schools,
                opportunities, and everything you need for a successful
                transition.
              </div>
            </div>
          </div>

          <div
            ref={box9Ref}
            className={`icon-title-text-container animate__animated ${box9InView ? "animate__zoomInRight" : ""}`}
          >
            <img
              src={girlieIMG}
              className="boxed-icon"
              alt="INTERNATIONAL BUSINESS WITH FOREIGNERS"
            />
            <div className="title-text">
              <h2 className="box-title">
                INTERNATIONAL BUSINESS WITH FOREIGNERS
              </h2>
              <div className="hero-description">
                Seamlessly conduct international transactions, manage foreign
                investments, and build strong financial partnerships with global
                banking solutions.{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
